import React, { useEffect, useState } from "react";
import "./styles.scss";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import Scrollbars from "react-custom-scrollbars-2";
import { useDispatch, useSelector } from "react-redux";
import { DropBox, FormHeader, TabComponent } from "../../../components";
import { getDatabases, getTables } from "../services/dataWarehouse.service";
// import { FcPuzzle, FcSearch, FcSettings, FcSynchronize } from "react-icons/fc";
import { PiFolderOpenFill } from "react-icons/pi";
import {
  setDatabaseList,
  setSelectDatabase,
  setSelectTable,
} from "../redux/actions";
import BackUp from "./backup";
import Restore from "./restore";

const WarehouseDashboard = () => {
  const [viewPointWidth, setViewPointWidth] = useState(0);
  const [viewPointHeight, setViewPointHeight] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [formData, setFormData] = useState({
    database: {
      key: "database",
      label: "Select Database",
      size: "lg",
      placeholder: "-",
      mainLayerStyles: " flex-column align-content-center ",
      iconName: "",
      isRequired: false,
      loading: false,
      elementConfig: {
        options: [],
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
  });

  const { dbTypes, selectDB, selectTable } = useSelector(
    ({ warehouseReducer }) => warehouseReducer
  );

  const dispatch = useDispatch();

  // scrollbars start
  useEffect(() => {
    updateWindowDimensions();
    window.addEventListener("resize", updateWindowDimensions);
    window.addEventListener("scroll", handleOnScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return () => {
      window.removeEventListener("scroll", handleOnScroll);
      window.removeEventListener("resize", updateWindowDimensions);
    };
  }, []);

  const updateWindowDimensions = () => {
    setViewPointWidth(window.innerWidth);
    setViewPointHeight(window.innerHeight);
  };

  const handleOnScroll = () => {
    let scrollTop =
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop;
    let scrollHeight =
      (document.documentElement && document.documentElement.scrollHeight) ||
      document.body.scrollHeight;
    let clientHeight =
      document.documentElement.clientHeight || window.innerHeight;
  };
  // scrollbars end

  const fetchDatabases = async (fileName) => {
    try {
      let body = {
        db_type: dbTypes.find((dbType) => dbType.value === fileName)
          ?.displayValue,
        config_file: fileName,
      };
      const response = await getDatabases(body);
      console.log("Get Databases : ", response);
      if (response?.data?.status) {
        const updateForm = { ...formData };
        updateForm["database"].elementConfig.options =
          response?.data?.databases.map((db) => ({
            value: db,
            displayValue: db,
          }));
        updateForm["database"].loading = false;
        setFormData(updateForm);
        dispatch(setDatabaseList(updateForm["database"].elementConfig.options));
        setTableList([]);
      } else {
        console.log("Data Not Found");
        setIsLoading(false);
      }
    } catch (error) {
      console.log("Error fetching Data", error);
      setIsLoading(false);
    }
  };

  const fetchTables = async (databaseName, fileName) => {
    try {
      let body = {
        db_type: dbTypes.find((dbType) => dbType.value === fileName)
          ?.displayValue,
        db_name: databaseName,
        config_file: fileName,
      };
      const response = await getTables(body);
      console.log("Get All Live Feed : ", response);
      if (response?.data?.status) {
        setTableList(response?.data?.tables);
        setIsLoading(false);
      } else {
        console.log("Data Not Found");
        setIsLoading(false);
      }
    } catch (error) {
      console.log("Error fetching Data", error);
      setIsLoading(false);
    }
  };

  const onChange = (key) => {
    console.log(key);
  };

  const items = [
    {
      key: "viewData",
      label: "🔍 View data",
      children: "",
    },
    {
      key: "backup",
      label: "🧩 Backup DB",
      children: <BackUp />,
    },
    {
      key: "restore",
      label: "🔁 Restore DB",
      children: <Restore />,
    },
    {
      key: "settings",
      label: "⚙️ Settings",
      children: "",
    },
  ];

  useEffect(() => {
    if (selectDB !== "") {
      const updateForm = { ...formData };
      updateForm["database"].loading = true;
      setFormData(updateForm);
      fetchDatabases(selectDB);
    }
  }, [selectDB]);

  useEffect(() => {
    if (formData.database.value !== "") {
      setIsLoading(true);
      fetchTables(formData.database.value, selectDB);
    }
  }, [formData.database.value, selectDB]);

  const updateForm = { ...formData };

  return (
    <>
      <div className="row border-top">
        <div className="col-3 dashboard-body-wrapper">
          <div style={{ minWidth: "205px" }}>
            <DropBox
              data={updateForm.database}
              onChange={(e) => {
                const updateForm = { ...formData };
                updateForm["database"].value = e;
                dispatch(setSelectDatabase(e));
                setFormData(updateForm);
              }}
            />
          </div>
          <div className="hne-body-wrapper">
            <FormHeader
              data={{
                formHeader: "Tables",
                size: "md-sm mb-2",
              }}
            />
            <Scrollbars
              onScroll={handleOnScroll}
              renderView={(props) => (
                <div
                  {...props}
                  style={{ ...props.style, overflowX: "hidden" }}
                />
              )}
              style={{ height: viewPointHeight - 310, marginRight: "-20px" }}
            >
              <div className="table-list-wrapper mb-4">
                {isLoading ? (
                  <div className="loading">Loading...</div>
                ) : (
                  tableList.map((table, index) => (
                    <div
                      key={index}
                      className={`table-item ${
                        selectTable === table ? "active" : ""
                      }`}
                      onClick={() => {
                        dispatch(setSelectTable(table));
                      }}
                    >
                      📁  {table}
                    </div>
                  ))
                )}
              </div>
            </Scrollbars>
          </div>
        </div>

        {/*right side*/}
        <div className="col-9 border-left">
          <TabComponent items={items} onChange={onChange} />
        </div>
      </div>
    </>
  );
};
export default withRouter(WarehouseDashboard);
